<template>
  <div class="d-flex justify-center items-center" style="height: 100vh">
    <n-result
      status="success"
      title="Success"
      description="Your form submitted successfully!"
    >
    </n-result>
  </div>
</template>